export const constants = {
  name: 'Alejandro Guzman',
  avatar: 'https://avatars.githubusercontent.com/u/91171864?v=4',
  profilesUrls: {
    linkedin: 'https://www.linkedin.com/in/alejandro-soriano-guzm%C3%A1n/',
    github: 'https://github.com/AsheeOF',
    email: 'sogaale201@outlook.com',
    cv: '',
    twitter: 'https://twitter.com/Ashee_OF',
    number: ' ',
    whatsapp: 'https://wa.me/2281854430',
    instagram: 'https://www.instagram.com/alejandro_.guzman/',
    facebook: '',
    Kofi: 'https://ko-fi.com/ashee_ashi',
  },
  icons: {
    linkedin: 'https://i.imgur.com/z5abyyx.png',
    github: 'https://i.imgur.com/IDzgJgj.png',
    email: 'https://i.imgur.com/T7Zqh03.png',
    twitter: 'https://i.imgur.com/XOaGLwf.png',
  },
  cursos: {},
  language: 'es_mx',
  siteData: {
    siteUrl: '',
    siteRepo: '',
  },
};
export default constants;
